export const mockRoomListResponse = {
  rescode: 1,
  message: "Rooms fetched successfully",
  data: [
    { id: 1, name: "Room A — Speech",     color: "#7A6EFE", capacity: 1, is_active: 1, sort_order: 0 },
    { id: 2, name: "Room B — OT",         color: "#F59E0B", capacity: 1, is_active: 1, sort_order: 1 },
    { id: 3, name: "Sensory Room",         color: "#EC4899", capacity: 2, is_active: 1, sort_order: 2 },
    { id: 4, name: "Group Room",           color: "#10B981", capacity: 10, is_active: 1, sort_order: 3 },
    { id: 5, name: "Room C — Physio",      color: "#0EA5E9", capacity: 1, is_active: 1, sort_order: 4 },
    { id: 6, name: "Assessment Room",      color: "#6366F1", capacity: 2, is_active: 1, sort_order: 5 },
    { id: 7, name: "Play Therapy Room",    color: "#F97316", capacity: 3, is_active: 1, sort_order: 6 },
  ],
};
